import React from 'react';
import { LottieComponent } from './Lottie';
import { VideoTheme } from '../../types';
import { loadFont as notoColorFont } from '@remotion/google-fonts/NotoColorEmoji';

const { fontFamily: notoFontFamily } = notoColorFont();

interface EmojiDisplayProps {
  emoji: string;
  theme: VideoTheme;
  emojiAnimationData: any;
}

const EmojiDisplayComponent: React.FC<EmojiDisplayProps> = ({
  emoji,
  theme,
  emojiAnimationData,
}) => (
  <div
    style={{
      ...styles.emojiContainer,
      fontSize: (theme?.fontStyle?.fontSize || 0) + 50,
      height: (theme?.fontStyle?.fontSize || 0) + 50,
      width: (theme?.fontStyle?.fontSize || 0) + 50,
      fontFamily: notoFontFamily,
      top: `-${(theme?.fontStyle?.fontSize || 100) + 50}px`,
    }}
  >
    {theme.captionStyle.emojiAnimation && emoji ? (
      <LottieComponent
        emoji={emoji}
        emojiCode={emoji?.codePointAt(0)?.toString(16) || null}
        emojiAnimationData={emojiAnimationData}
      ></LottieComponent>
    ) : (
      emoji || ''
    )}
  </div>
);

const styles: { [key: string]: React.CSSProperties } = {
  emojiContainer: {
    position: 'absolute',
    top: '-90px',
    fontSize: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

// Memoize the component
export const EmojiDisplay = React.memo(EmojiDisplayComponent, (prevProps, nextProps) => {
  return prevProps.emoji === nextProps.emoji && prevProps.theme === nextProps.theme;
});
